import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Divider,
  Grid,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import MappingPresetList from '../../components/MappingPresetList';
import NavBar from '../../components/NavBar';
import { TRANSLATION_FILES } from '../../constants/translation';

class List extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static getPropsToState = (props) => {
    const loading = props.loading;
    return {
      loading,
    };
  }
  constructor(props) {
    super(props);
    const state = List.getPropsToState(props);
    this.state = state;
  }
  componentWillReceiveProps(nextProps) {
    const state = List.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  render() {
    const { t } = this.props;
    return (
      <Container>
        <NavBar
          header={t('Project Mapping Settings')}
        />
        <Grid verticalAlign="middle" columns="equal" stackable>
          <Grid.Row>
            <Grid.Column>
              <Divider horizontal>{t('Mapping Presets')}</Divider>
              <MappingPresetList
                loading={this.state.loading}
                type="projects"
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}
export default withTranslation(TRANSLATION_FILES.screens)(List);



// WEBPACK FOOTER //
// ./src/containers/ProjectMappings/List.jsx